import { VouchersGetAllBody } from "@/lib/redux/features/voucher/voucherApiV3.types"

export type VoucherMarket = "DOMESTIC" | "INTERNATIONAL"

export const getVoucherMarket = (isDomestic: boolean): VoucherMarket =>
  isDomestic ? "DOMESTIC" : "INTERNATIONAL"

/** API get-all chỉ nhận coarse types (FLIGHT, HOTEL, ESIM), không HOTELQN/HOTELQT. */
export const resolveVouchersGetAllProductTypes = (
  productTypes?: string[],
): string[] => {
  if (!productTypes?.length) return ["FLIGHT"]

  const set = new Set<string>()
  for (const p of productTypes) {
    if (p.startsWith("FLIGHT")) set.add("FLIGHT")
    else if (p.startsWith("HOTEL")) set.add("HOTEL")
    else if (p === "ESIM") set.add("ESIM")
    else set.add(p)
  }
  return [...set]
}

type BuildVouchersGetAllBodyOptions = {
  clientId?: string
  /** Khi set → thêm `markets: [DOMESTIC|INTERNATIONAL]` */
  isDomestic?: boolean
  voucherTypes?: string[]
  productTypes?: string[]
  includeCodes?: boolean
  codesLimit?: number
}

/** Payload gửi API (bỏ `TYPE` — chỉ dùng cho fetch/appFetch trực tiếp). */
export const toVouchersGetAllApiPayload = ({
  TYPE: _type,
  ...apiBody
}: VouchersGetAllBody): Omit<VouchersGetAllBody, 'TYPE'> => apiBody

export const buildVouchersGetAllBody = (
  options: BuildVouchersGetAllBodyOptions = {},
): VouchersGetAllBody => {
  const body: VouchersGetAllBody = {
    TYPE: 'JSON',
    clientId: String(
      options.clientId ?? process.env.NEXT_PUBLIC_AUTHEN_API_CLIENT_ID ?? 'TE',
    ),
    includeCodes: options.includeCodes ?? true,
    codesLimit: options.codesLimit ?? 5,
    productTypes: resolveVouchersGetAllProductTypes(options.productTypes),
  }

  if (options.isDomestic !== undefined) {
    body.markets = [getVoucherMarket(options.isDomestic)]
  }

  if (options.voucherTypes?.length) {
    body.voucherTypes = options.voucherTypes
  }

  return body
}
